/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

export interface ContentCityLongTermRentalsProps {
  cityName: string;
}

export const ContentCityLongTermRentals = ({
  cityName,
}: ContentCityLongTermRentalsProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Long Term Rentals in ${cityName}, Netherlands`}
      </Typography>

      <Typography variant="body1" className={styles.paragraph}>
        {`Searching for long term rentals in ${cityName}? Look no further! Kamernet
        takes the stress out of booking a long stay rental in ${cityName}. As
        Netherlands’ trusted platform, Kamernet specializes in long term
        accommodation in ${cityName} for students and traveling professionals.
        Whether you’re seeking long term apartments, long stay studios or rooms
        in ${cityName} for long term, Kamernet connects you with quality listings
        that suit your lifestyle and rental goals.`}
      </Typography>

      <Typography variant="h3" className={styles.title}>
        {`Benefits of Renting Long-Term Housing in ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Renting long-term housing in ${cityName} provides greater security and value
        over time. Ideal for students, working professionals, or expats planning
        an extended stay, long-term rentals allow you to settle in without the
        constant stress of renewing or moving. Whether you’re staying for a work
        assignment or uni semester, long-term rentals in ${cityName} offer a more
        permanent, affordable, and homey solution for living in the city.`}
      </Typography>

      <Typography variant="h3" className={styles.title}>
        {`Why choose a long term rental in ${cityName}?`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`There are many reasons you might want to rent in ${cityName} for long term.
        Perhaps you’re relocating for a job, pursuing a degree, or simply
        planning to immerse yourself in Dutch life. An apartment rental in
        ${cityName} for long term gives you the space and stability to live more
        comfortably and independently. When you rent an apartment in ${cityName} for
        the long term, you can choose to live in a neighbourhood that matches
        your lifestyle. It’s often more affordable than short-stay options if
        you’re staying longer than six months. You also get more space and
        convenience compared to a hotel or short let, with your own kitchen,
        living area, and laundry facilities that make day-to-day living easier
        and more comfortable.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Why Kamernet?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`It’s becoming increasingly common to rent long term apartments in
        ${cityName}, and demand is rising steadily. That doesn’t mean finding your
        ideal place in ${cityName} has to be difficult. Using a trustworthy platform
        like Kamernet makes it simple to find a long-term rental that matches
        your preferences and budget. Rent a flat in ${cityName} for long term today
        and enjoy all the comforts of home away from home.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Lange termijn huren in ${cityName}, Nederland`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar lange termijn huren in ${cityName}? Zoek niet verder! Kamernet
        maakt het vinden van een geschikte woning in ${cityName} een stuk
        eenvoudiger. Als vertrouwd platform in Nederland specialiseert Kamernet
        zich in lange termijn accommodatie in ${cityName} voor studenten en werkende
        professionals. Of je nu een appartement te huur in ${cityName} voor lange
        termijn zoekt, of liever een studio of kamer, Kamernet verbindt je met
        betrouwbare aanbiedingen die aansluiten op jouw woonwensen en
        levensstijl.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        {`Voordelen van een woning huren in ${cityName} voor lange termijn`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Een woning huren in ${cityName} voor lange termijn biedt meer zekerheid en
        wooncomfort op de lange termijn. Het is ideaal voor studenten, young
        professionals of expats die voor langere tijd in de stad willen
        verblijven. Je hoeft je geen zorgen te maken over telkens verlengen of
        verhuizen. Of je nu in ${cityName} verblijft voor een studie, werkopdracht of
        persoonlijke reden, lange termijn huren in ${cityName} zorgt voor een
        stabiele en betaalbare woonoplossing.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        {`Waarom kiezen voor een appartement of huis huren in ${cityName} voor lange
        termijn?`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Er zijn veel goede redenen om te kiezen voor een appartement huren in
        ${cityName} voor lange termijn. Misschien verhuis je voor een nieuwe baan,
        begin je met een studie of wil je het Nederlandse leven van dichtbij
        ervaren. Een huis huren in ${cityName} voor lange termijn geeft je de
        mogelijkheid om te wonen in een buurt die echt bij je past. Deze optie
        is vaak voordeliger dan kort verblijf, zeker bij een huurperiode van
        meer dan zes maanden. Bovendien biedt een woning meer ruimte, privacy en
        praktische voorzieningen zoals een keuken, woonkamer en wasmachine.`}
      </Typography>

      <Typography variant="h3" className={styles.title}>
        {`Vind een appartement te huur in ${cityName} voor lange termijn`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Het wordt steeds gebruikelijker om appartementen te huren in ${cityName} voor
        lange termijn, waardoor de concurrentie toeneemt. Gelukkig hoef je met
        Kamernet niet lang te zoeken. Via ons betrouwbare platform vind je snel
        en zonder gedoe een appartement of huis dat past bij jouw budget en
        woonvoorkeuren. Lange termijn huren in ${cityName} geeft je de vrijheid en
        rust om je echt thuis te voelen, vanaf dag één.`}
      </Typography>
    </React.Fragment>
  );
};
